import { FC } from 'react';
import { ErrorRounded } from '@mui/icons-material';
import { Stack } from '@mui/material';

import { LocalizationTypography } from '~components/organisms/localization';

export const InsufficientBalanceAlert: FC = () => (
  <Stack
    direction="row"
    alignItems="flex-start"
    spacing={1.5}
    sx={{
      bgcolor: 'error.light',
      color: 'error.main',
      borderRadius: 2,
      p: 1.5,
    }}
  >
    <ErrorRounded sx={{ color: 'error.main' }} />
    <Stack>
      <LocalizationTypography
        variant="Poppins/Subheading-sm"
        color="error.main"
        textId="app.rentalPage.newStepThree.rentCharger.insufficientCampusCardBalance.title"
        defaultText="Not enough Campus Card balance"
      />
      <LocalizationTypography
        color="error.main"
        textId="app.rentalPage.newStepThree.rentCharger.insufficientCampusCardBalance.subtitle"
        defaultText="Add funds to your campus card or switch payment method."
      />
    </Stack>
  </Stack>
);
